import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class PmoProgramService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAllPrograms = (): Observable<PmoProgram[]> => {
    return this.apiHttp.get<PmoProgram[]>("pmoprograms");
  };

  public getProjects = (
    queryModel: PmoProjectsQueryModel
  ): Observable<PmoProject[]> => {
    return this.apiHttp.get<PmoProject[]>(
      `pmoprograms/${queryModel.pmoProgramKey}/projects`
    );
  };
}

export interface PmoProjectsQueryModel {
  pmoProgramKey: string;
}

export interface PmoProgram {
  programKey: string;
  pmoProgramName: string;
  activeProjectCount: number;
  isActive: boolean;
}

export interface PmoProject {
  projectKey: string;
  pmoProjectName: string;
  prismId: number;
  isActive: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/pmo-program.service.ts